export enum JobStatus {
  ENQUEUED = 'Enqueued',
  EXECUTING = 'Executing',
  SUCCESS = 'Success',
  FAILED = 'Failed',
  ERROR = 'Error',
}

export interface DownloadJob {
  downloadUrl: string;
  downloadExpires: string;
  id: string;
  startedAt: string;
  status: string;
  descriptionKey: string;
  description: string;
  finishedAt: string;
  progress: number;
  estimatedFinish: string;
  result: string;
  resultKey: string;
  type: string;
}

export interface DownloadCustomerJob extends DownloadJob {
  customerIds: number[];
  filterByTags: string[];
  allCustomers: boolean;
}

export interface DownloadInvoiceJob extends DownloadJob {
  invoiceYear: number;
  invoiceMonth: number;
  providerUUID: string;
  invoicesCount: number;
}
